/**
 * This will take a hsl and convert it to the closest hex value
 * @param hsl The hsl to be converted
 * @returns string of the hex value (with #)
 */
export const hslToHex = (hsl) => {
    if (!hsl) {
        // Default MH primary color
        return `#0044FF`;
    }
    const light = (hsl.lightness /= 100);
    const alpha = (hsl.saturation * Math.min(light, 1 - light)) / 100;
    // Maths bellow explained here: https://en.wikipedia.org/wiki/HSL_and_HSV#HSL_to_RGB_alternative
    const f = (n) => {
        const k = (n + hsl.hue / 30) % 12;
        const color = light - alpha * Math.max(Math.min(k - 3, 9 - k, 1), -1);
        return Math.round(255 * color)
            .toString(16)
            .padStart(2, "0"); // convert to Hex and prefix "0" if needed
    };
    return `#${f(0)}${f(8)}${f(4)}`;
};
//# sourceMappingURL=color.js.map